// extracted by mini-css-extract-plugin
module.exports = {"Error":"styles_Error__5nx1r"};